module.exports = __webpack_public_path__ + "media/37.7e8176e3.mp3";